export const GOOGLE_MAPS_APIKEY = "AIzaSyDkVczBWXo9pScgK8WNi4Q-9qlvn_KFn0A";
export const DEFAULT_LATLNG = {
  lat: 13.7563,
  lng: 100.5018,
};
